import { Track } from "@farmact/model/src/model/Track";
import { query, where } from "firebase/firestore";
import { Firebase } from "../../../index";

export function getQueryForTracksWithIds(trackIds: Track["id"][]) {
    return query(Firebase.instance().getAllTracks(), where("id", "in", trackIds));
}
